import { getDatabase, ref, update } from "firebase/database";
import dayjs from "dayjs";
import { AlertName, AlertType } from "helpers/alert-type";
import { alertHelper } from "helpers/alert-helper";
import { AlertLogConfig } from "services/session-token";
import { Dispatch } from "redux";
import { SessionScope, firebaseCollections } from "globals/enums";

import { getSystemTime } from "helpers/common";
import { participantGroupSessionPath } from "helpers/firebase-path";

export const markCandidateMessagesAsReadInFirebase = async (
  session_id: number,
  session_type: SessionScope,
  participantGroupId: number,
  messages,
  alertConfig: AlertLogConfig[],
  dispatch: Dispatch
) => {
  if (!messages) {
    return;
  }
  if (
    session_type === SessionScope.LiveProctor &&
    !(typeof participantGroupId === "number" && participantGroupId > 0)
  ) {
    return;
  }
  const database = getDatabase();
  await Promise.all(
    Object.keys(messages).map(async (messageKey: any) => {
      const message = messages[messageKey];
      if (message.role !== "candidate" && !message.read_at) {
        const messageRef = ref(
          database,
          session_type === SessionScope.LiveProctor
            ? participantGroupSessionPath(participantGroupId, session_id, `messages/${messageKey}`)
            : `${firebaseCollections.SessionV2}/${session_id}/messages/${messageKey}`
        );
        if (message?.alert_type_id && message?.metadata) {
          const alertName = getAlertNameById(message.alert_type_id);
          if (
            message.alert_type_id === AlertType[AlertName.ProctoringSessionExtended].id &&
            alertName
          ) {
            alertHelper(alertConfig).raiseAlert(
              alertName,
              dispatch,
              message.description || alertName,
              message.metadata,
              true
            );
          } else {
            window.ProctorClient3.trigger(`log:event:all log:event:type:${message.alert_type_id}`, {
              alert_type_id: message.alert_type_id,
              description: alertName,
              payload: message.metadata
            });
          }
        }
        await update(messageRef, {
          received_at: getSystemTime().toISOString(),
          read_at: getSystemTime().toISOString()
        });
      }
    })
  );
};

export const formatDate = (date: string) => {
  return date ? dayjs(date).format("hh:mm A") : "";
};

const getAlertNameById = (id: number): AlertName | undefined => {
  return Object.values(AlertType).find((alert) => alert.id === id)?.alertName;
};
